export default function ModuleBg({ children }) {
    return (
        <div className="min-h-full" style={{ background: 'var(--bg-page)' }}>
            {children}
        </div>
    );
}
